export default __webpack_public_path__ + "deliver-3846159.png";